import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { BackToMenu } from "../features/menu/back-link";
import { CategoryFormView } from "../features/menu/category-form";
import { useInPanes } from "../features/menu/panes";
import { Require } from "../features/require";

export const Route = createFileRoute("/menu/categories/$categoryId")({ component: Page });

function Page() {
	const { categoryId } = Route.useParams();
	const navigate = useNavigate();
	const inPanes = useInPanes();
	return (
		<Require permission="menu.edit">
			<div className="max-w-3xl">
				<CategoryFormView
					key={categoryId}
					categoryId={categoryId}
					back={<BackToMenu to="/menu/categories" />}
					onSaved={() => {
						if (!inPanes) void navigate({ to: "/menu/categories" });
					}}
					onDeleted={() => void navigate({ to: inPanes ? "/menu" : "/menu/categories" })}
				/>
			</div>
		</Require>
	);
}
